import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { MatTable } from '@angular/material/table';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { GlobalFunctionsService } from '@_services/global-functions.service';
import { Subject, takeUntil } from 'rxjs';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-exchange-rates',
  templateUrl: './exchange-rates.component.html',
  styleUrls: ['./exchange-rates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExchangeRatesComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  isspiner: boolean = false;
  confirmDialogRef: any;
  secondData: boolean = true;
  firstData: boolean = false;
  getDataForTable: any = [];
  highlightedRows: any;
  theme_type: string | null = localStorage.getItem('theme_type');
  selectedColore: string = 'var(--highlighted-bg-row)';
  showDate: any;
  sendDate: any;
  whichType: any;
  FormAction: any;
  CurrentRowselcted: any = {};
  sendExchangeGUID: any;
  displayedColumns: string[] = ['Action', 'name', 'rate'];
  @Output() callLoading = new EventEmitter<string>();
  dropDownVal: any;
  maintainFlag: boolean = false;
  ShowDuplicateBotton: boolean = false;
  @ViewChild(MatTable) table: MatTable<any>;
  isExpandedRow = (_index: number, row: any): boolean => !!row?.expanded;
  private _unsubscribeAll$: Subject<void> = new Subject();
  lookupsData: any;

  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    public _matDialog: MatDialog,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private globalFunService: GlobalFunctionsService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingExchangeRatesComponent');
    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (
          localStorage.getItem('istrackid') == 'SystemSettingExchangeRatesComponent' &&
          result['click'] &&
          result['data']['exchange-rate']
        ) {
          this.finalSave('save');
        }
        this.cd.markForCheck();
      },
    });
  }

  ngOnInit() {
    this.SettingForm.controls['CURRENCYID'].setValue('USD');
    this.SettingForm.get('EFFECTIVEDATE').disable();
    this.SettingForm.get('RATE').disable();
    this.SettingForm.controls['EFFECTIVEDATE'].setValue(new Date());
    this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(
      this.datepipe.transform(new Date(), 'dd/MM/yyyy'),
    );
    this.SettingForm.controls['RATE'].setValue(0);
    this.dropDownVal = 'USD';
    this.loadData();
    this.getLookupData();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to load the data value.
   */
  loadData() {
    this._mainAPiServiceService
      .getSetData(
        {
          Action: 'GetData',
          FILTERS: { CURRENCYID: this.dropDownVal },
        },
        'exchange-rate',
      )
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            this.getDataForTable = [];
            //this.getDataForTable = response.DATA.EXCHANGERATES;
            response.DATA.RECORDS.forEach((element: any) => {
              element['expanded'] = false;
              this.getDataForTable = response.DATA.RECORDS;
            });
            this.maintainFlag = false;
            if (this.getDataForTable.length > 0) {
              this.rowclick(this.getDataForTable[0]);
              this.CurrentRowselcted = this.getDataForTable[0];
              this.itemChange('edit');
              this.highlightedRows = this.getDataForTable[0].EXCHANGERATEGUID;
            }

            this.behaviorService.loadingSystemSetting('exchange-rates');
            // this.isLoadingResults = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
  get f() {
    return this.SettingForm.controls;
  }
  async CurrencyClassChange(val: any) {
    this.dropDownVal = val;
    await this.loadData();
    this.cd.markForCheck();
  }

  /**
   * This functionis used to change the item data
   */
  itemChange(val: any) {
    this.whichType = val;
    if (val == 'add') {
      this.secondData = false;
      this.SettingForm.get('EFFECTIVEDATE').enable();
      this.SettingForm.get('RATE').enable();
      setTimeout(() => {
        this.SettingForm.controls['EFFECTIVEDATE'].setValue('');
        this.SettingForm.controls['RATE'].setValue('');
        this.SettingForm.controls['sendEFFECTIVEDATE'].setValue('');
        this.cd.markForCheck();
      }, 500);

      this.firstData = true;
    } else if (val == 'edit') {
      // if(!isNaN(this.CurrentRowselcted.EFFECTIVEDATE)){
      let date = this.CurrentRowselcted.EFFECTIVEDATE.split('/');
      let sendDate = new Date(date[1] + '/' + date[0] + '/' + date[2]);
      this.SettingForm.controls['EFFECTIVEDATE'].setValue(sendDate);
      this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(this.CurrentRowselcted.EFFECTIVEDATE);
      // }
      this.SettingForm.controls['RATE'].setValue(this.CurrentRowselcted.RATE);
      this.secondData = false;
      this.SettingForm.get('EFFECTIVEDATE').enable();
      this.SettingForm.get('RATE').enable();
      this.firstData = true;
    } else if (val == 'delete') {
      this.finalSave(val);
    } else if (val == 'DUPLICATE') {
      this.finalSave(val);
    }
    this.cd.markForCheck();
  }

  /**
   * This function is used to exchange the Date1 data value.
   */
  exchangeDate1(val1: any, val2: any): void {}

  /**
   * This function is used to exchange the Date
   */
  exchangeDate(type: string, event: MatDatepickerInputEvent<Date>): void {
    this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
    this.cd.markForCheck();
  }

  /**
   * This function is used to dont Save the data avlue.
   */
  dontsave(): void {
    this.firstData = false;
    this.secondData = true;
    this.SettingForm.get('EFFECTIVEDATE').disable();
    this.SettingForm.get('RATE').disable();
    this.cd.markForCheck();
  }

  /**
   * This function is used to click on the row
   */
  async rowclick(val: any) {
    this.CurrentRowselcted = val;
    this.highlightedRows = val.EXCHANGERATEGUID;
    // await this.itemChange('edit');
    this.cd.markForCheck();
  }

  /**
   * This function is used to Final Save
   *  */
  finalSave(val: any): void {
    this.firstData = false;
    this.secondData = true;
    // this.SettingForm.get('EFFECTIVEDATE').disable();
    // this.SettingForm.get('RATE').disable();
    if (this.whichType == 'add') {
      this.FormAction = 'insert';
      this.sendExchangeGUID = '';
    } else if (this.whichType == 'edit') {
      this.FormAction = 'update';
      this.sendExchangeGUID = this.CurrentRowselcted.EXCHANGERATEGUID;
    } else if (this.whichType == 'delete') {
      this.FormAction = 'delete';
      this.sendExchangeGUID = this.CurrentRowselcted.EXCHANGERATEGUID;
    } else if (this.whichType == 'DUPLICATE') {
      this.FormAction = 'insert';
      this.sendExchangeGUID = '';
    }
    let sendData: any = {
      CURRENCYID: this.dropDownVal,
      EXCHANGERATEGUID: this.sendExchangeGUID,
      EFFECTIVEDATE: this.f.sendEFFECTIVEDATE.value,
      RATE: this.f.RATE.value,
    };
    if (this.whichType == 'DUPLICATE') {
      delete sendData.EXCHANGERATEGUID;
    }

    let details = {
      FormAction: this.FormAction,
      VALIDATEONLY: true,
      Data: sendData,
    };
    this._mainAPiServiceService
      .getSetData(details, 'exchange-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.checkValidation(response.DATA.VALIDATIONS, details);
            this.maintainFlag = false;
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.checkValidation(response.DATA.VALIDATIONS, details);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.checkValidation(response.DATA.VALIDATIONS, details);
          } else if (response.MESSAGE == 'Not logged in') {
            // this.dialogRef.close(false);
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  // checkValidation(bodyData: any, details: any) {
  //   let errorData: any = [];
  //   let warningData: any = [];
  //   let tempError: any = [];
  //   let tempWarning: any = [];
  //   bodyData.forEach(function (value) {
  //     if (value.VALUEVALID == 'No') {
  //       errorData.push(value.ERRORDESCRIPTION);
  //       tempError[value.FIELDNAME] = value;
  //     }
  //     else if (value.VALUEVALID == 'Warning') {
  //       tempWarning[value.FIELDNAME] = value;
  //       warningData.push(value.ERRORDESCRIPTION);
  //     }
  //   });
  //   this.errorWarningData = { "Error": tempError, 'Warning': tempWarning };
  //   if (Object.keys(errorData).length != 0) {
  //     this.toastr.error(errorData);
  //     this.isspiner = false;
  //   } else if (Object.keys(warningData).length != 0) {
  //     this.isspiner = false;
  //     this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
  //       disableClose: true,
  //       width: DIALOG_WIDTH.FULL,
  //       data: warningData
  //     });
  //     this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to Save?';
  //     this.confirmDialogRef.afterClosed().subscribe(result => {
  //       if (result) {
  //         this.isspiner = true;
  //         this.saveExchangeData(details);
  //       }
  //       this.confirmDialogRef = null;
  //     });
  //   } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
  //     this.saveExchangeData(details);

  //   }
  // }

  /**
   * This function is used to check the validation data value
   */
  async checkValidation(bodyData: any, PostActivityData: any, ApiName?: any) {
    this.isspiner = false;
    await this.globalFunService
      .checkValidation(bodyData, PostActivityData)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.errorWarningData = data.errorWarningData;
            //this.errorWarningDataArray = data.errorWarningData;
            if (data.callback) {
              this.saveExchangeData(PostActivityData);
            }
          }
          this.cd.markForCheck();
        },
        error: (err: any) => {
          console.error(err);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This function is used to save the Exchnage date value
   */
  saveExchangeData(data: any): void {
    data.VALIDATEONLY = false;
    this._mainAPiServiceService
      .getSetData(data, 'exchange-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            if (this.whichType == 'add') {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Saved successfully');
            } else if (this.whichType == 'edit') {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Updated successfully');
            } else {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Deleted successfully');
              this.maintainFlag = false;
            }
            // this.dialogRef.close(true);
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.toastr.warning(response.MESSAGE);
            this.isspiner = false;
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.toastr.error(response.MESSAGE);
            this.isspiner = false;
          } else if (response.MESSAGE == 'Not logged in') {
            // this.dialogRef.close(false);
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This function is used to delete the Item data value
   */
  deleteItem(): void {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          let postData = {
            FormAction: 'delete',
            DATA: {
              EXCHANGERATEGUID: this.CurrentRowselcted.EXCHANGERATEGUID,
            },
          };
          this._mainAPiServiceService.getSetData(postData, 'exchange-rate').subscribe({
            next: (res: any) => {
              if (res.STATUS == 'success' && res.CODE == 200) {
                this.callLoading.next(null);
                this.loadData();
                this.toastr.success('Deleted successfully');
              }
              this.cd.markForCheck();
            },
            error: (err: any) => {
              console.error(err);
              this.cd.markForCheck();
            },
          });
        }
        this.confirmDialogRef = null;
        this.cd.markForCheck();
      },
    });
  }

  /**
   * This function is used to toggle the row data values
   */
  async toggleRow(element: any) {
    this.ShowDuplicateBotton = false;
    this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(element.EFFECTIVEDATE);
    this.CurrentRowselcted = element;
    await this.itemChange('edit');
    this.maintainFlag = false;
    if (element.expanded == true) {
      element.expanded = !element.expanded;
    } else {
      // Uncommnet to open only single row at once
      this.getDataForTable.forEach((row: any) => {
        row.expanded = false;
      });
      element.expanded = !element.expanded;
    }
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  /**
   * This function is used to Add the duplicate data
   */
  AddDuplicateData(): void {
    this.maintainFlag = false;
    this.itemChange('edit');
    this.ShowDuplicateBotton = false;
    this.getDataForTable.forEach((row: any) => {
      row.expanded = false;
    });
    setTimeout(() => {
      this.getDataForTable.forEach((row: any) => {
        if (row.EXCHANGERATEGUID != this.CurrentRowselcted.EXCHANGERATEGUID) {
          row.expanded = false;
        } else {
          this.ShowDuplicateBotton = true;
          this.CurrentRowselcted.expanded = true;
        }
      });
      this.table?.renderRows();
      this.cd.markForCheck();
    }, 300);
    this.cd.markForCheck();
  }
  async getValue() {
    await this.itemChange('add');
    this.maintainFlag = true;
    this.getDataForTable.forEach((row: any) => {
      row.expanded = false;
    });
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  /**
   * This function is used to CollapstExtended rrow data value.
   */
  CollapstExpandedrow(): void {
    this.CurrentRowselcted.expanded = false;
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  getLookupData() {
    this.isspiner = true;
    this._mainAPiServiceService
      .getSetData({ Action: 'getdata', Filters: { LookupType: 'Contact Currency' } }, 'lookup')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            this.lookupsData = response.DATA.LOOKUPS;
            this.isspiner = false;
          } else {
            this.isspiner = false;
          }
        },
        error: (error: any) => {
          console.error(error);
          this.isspiner = false;
        },
      });
  }
}
